import './App.css';
import { useEffect } from 'react';

import Routes from './components/routes/routes';
import { useRoutes } from 'hookrouter';
import { withRouter } from 'react-router-dom';
import NavBar from '../src/components/NavBar/navbar';

function App() {
  return (
    <div className="App">
      {useRoutes(Routes) || (
        <>
          <NavBar />
          <h1>PAGE NOT FOUND</h1>
        </>
      )}
    </div>
  );
}

export default withRouter(App);
